export default {
    assigned_book: 'Tu libro asignado',
    challenges: 'Desafíos',
    challenges_desc: 'Supera los desafíos y gana premios.',
    empty_messages: 'Sin mensajes',
    empty_notifications: 'Sin notificaciones',
    my_books: 'Mis libros',
    my_profile: 'Mi perfil',
    my_subscriptions: 'Mis suscripciones',
    news_from_library: 'Novedades de la biblioteca',
    news_from_store: 'Novedades de tu tienda',
    no_book: 'No tiene libro asignado este mes.',
    no_super_recommended: 'No tenemos recomendaciones por el momento.',
    pending_readings: 'Más libros',
    pending_readings_desc: 'Anímate y finaliza tus libros.',
    ranking: 'Ranking',
    ranking_desc: 'Conoce los mejores puntajes.',
    reminder: 'Recordatorio',
    start_reading: 'Comenzar la lectura',
    store: 'Tienda',
    store_desc: 'Compra con tus Beecoins.',
    super_recommended: '¡Súper recomendado!',
    do_click: 'Debes hacer clic para ver el mensaje',
    no_message: 'Sin mensajes para mostrar',
    notification_text_1:
        'Recuerda continuar con tu libro asignado antes de que acabe el tiempo. Si deseas reanudar la lectura haz click aquí.',
    notification_text_2:
        'Estás a punto de vivir una experiencia de lectura única. Disfruta de las recomendaciones que tenemos para ti. Accede de inmediato y disfruta tus lecturas sugeridas.',
    notification_text_3:
        'Todo lo que necesitas para decorar tu plataforma a un solo clic. Accede a increíbles herramientas adicionales.',
}
